export * from '@primeuix/themes/aura/datatable';
export { default } from '@primeuix/themes/aura/datatable';
